import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { UpdateMethodType } from '../../constants/write-behavior-constants';

/*
    Activity Policy. TODO...
*/
@Metamodel.model({
    name: 'copysink',
    abstract: true
})
export class CopySink extends Named {
    public static readonly MODEL: IModel;
    public static readonly MAXCONCURRENT_CONNECTIONS: IAttribute;

    public writeBatchSize?: number;

    public writeBatchTimeout?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'MAXCONCURRENT_CONNECTIONS',
        display: shellStringResources.ModelName_MaxConcurrentConnections,
        constraint: {
            whole: true,
            minimum: 0
        }
    })
    public maxConcurrentConnections?: number;
}

export interface ICopySinkWithUpdateMethod extends CopySink {
    updateMethod: UpdateMethodType;

    upsertKeyColumns?: string[];
}
